const DOCUMENT_OWNER_LABELS = {
  child: "Student",
  father: "Father",
  mother: "Mother",
  application: "Application",
};

export const documentOwnerLabelForRole = (role) =>
  DOCUMENT_OWNER_LABELS[role] ||
  String(role || "")
    .split("_")
    .filter(Boolean)
    .map((word) => word[0]?.toUpperCase() + word.slice(1))
    .join(" ");